import Swiper, { Autoplay,Pagination  } from 'swiper';

window.HomeView = function (options) {
	const _self     = this,
		  _settings = {
			  ...{}, ...options
		  };

	function _init () {
		_initBailiffOfficeSearch();
		_initCitySWiper();
		_initLandingCitySWiper();
		_initBailiffsSwiper();

		if (window.matchMedia("(max-width: 1025px)").matches) {
			_initReviewSWiper()
		}
	}

	function _initBailiffOfficeSearch () {
		$('.js-search-entity-input').each(function (key, el) {
			const $input      = $(el),
				  $form       = $input.parents('.js-search-entity-form'),
				  awesomplete = new Awesomplete($input[0], {
					  replace: function (suggestion, ok) {
						  // $.text() permet de supprimer l'icon fontawesome présente dans le label
						  this.input.value = $('<span>' + suggestion.label + '</span>').text();
					  },
					  filter: function (text, input) {
						  return true;
					  }
				  });

			// Empêcher de submit le formulaire qui ne mène vers rien de toute façon
			$form.on('submit', function (e) {
				e.preventDefault();
			});

			// Chercher des huissiers/étude
			$input.on('keyup paste', _delay(function (e) {
				axios.post($input.data('action'), { search: $(this).val() }
				).then(function (r) {
					awesomplete.list = r.data;
					awesomplete.evaluate();
				}).catch(function (e) {
					toastr.error("Oups, il semblerait qu'une erreur soit survenue");
					console.error(e);
				});
			}, 300));

			// A la sélection d'un choix rediriger vers la page
			$input.on('awesomplete-select', function (e, d) {
				window.location.href = e.originalEvent.text.value;

				// Afficher un message pour faire patienter l'utilisateur si la redirection met trop de temps
				setTimeout(function () {
					$form.find('.js-loading-msg-link').attr('href', e.originalEvent.text.value);
					$form.find('.js-loading-msg').show();
				}, 500);
			});
		});
	}

	function _initCitySWiper () {
		const elClass = '.js-city-swiper'
		const citySwiper   = new Swiper(elClass, {
			modules: [Autoplay],
			spaceBetween: 10,
			direction: 'horizontal',
			allowTouchMove: true,
			slidesPerView: 4 ,
			speed: 2000,
			centerInsufficientSlides: true,
			loop: true,
			autoplay: {
				delay: 1500,
				disableOnInteraction: true,
			},
			breakpoints: {
				// when window width is <= 480px
				0: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 4,
				},
				992: {
					loop: false,
					allowTouchMove: false,
					slidesPerView: 9,
				}
			}
		});
	}
	function _initLandingCitySWiper () {
			const elClass = '.js-landing-city-swiper'
			const citySwiper   = new Swiper(elClass, {
				modules: [Autoplay],
				direction: 'horizontal',
				allowTouchMove: true,
				slidesPerView: 4,
				spaceBetween: 10,
				centerInsufficientSlides: true,

				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
				},
				speed: 1500,
				loop: true,
				center: true,

				breakpoints: {
					0: {
						slidesPerView: 1,
					},
					576: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 3,
					},
					1400: {
						allowTouchMove: false,
						slidesPerView: 4,
					}
				}
			});
	}

	function _initBailiffsSwiper () {
		const elClass = '.js-bailiffs-swiper'
		const bailiffsSwiper   = new Swiper(elClass, {
			modules: [Autoplay],
			spaceBetween: 30,
			direction: 'horizontal',
			allowTouchMove: false,
			slidesPerView: 1.4 ,
			speed: 10000,
			centeredSlides: true,
			centerInsufficientSlides: true,
			loop: true,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			breakpoints: {
				// when window width is <= 480px
				480: {
					slidesPerView: 2,
				},
				// when window width is <= 640px
				640: {
					slidesPerView: 3,
				},
				// when window width is <= 768px
				768: {
					slidesPerView: 5,
				},
				// when window width is <= 992px
				992: {
					slidesPerView: 6,
				},
				// when window width is <= 992px
				1400: {
					slidesPerView: 7,
				},
			}
		});


	}


	function _delay (callback, ms) {
		var timer = 0;
		return function () {
			var context = this, args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
				callback.apply(context, args);
			}, ms || 0);
		};
	}

	function _initReviewSWiper() {
		const elClass = '.js-reviews-swiper'
		const reviewsSwiper = new Swiper(elClass, {
			modules: [Autoplay,Pagination],
			spaceBetween: 10,
			direction: 'horizontal',
			allowTouchMove: true,
			slidesPerView: 1,
			speed: 2000,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: true,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true,
			},
		});
	}


	_init();
};
